import { Attributes } from '../../details/attributes/attributes';

export interface Payment {
  paymentUid: number;
  allocateUid: string;
  docType: string;
  bankNum: string;
  payType: string;
  payComments: string;
  payeeType: string;
  payTypeName: string;
  paymentType?: string; // Optional - not returned by GetPaymentById, compute: payTypeName + "/" + payType
  nameType: string;
  payee: string;
  address1: string;
  address2: string;
  address3: string;
  address?: string; // Optional - not returned by GetPaymentById, compute: address1 + " " + address2 + address3
  checkNum: string;
  chkCleared: boolean;
  dateClear: Date;
  protTaxId: string;
  pTaxsub: string;
  taxId?: string; // Optional - not returned by GetPaymentById, compute: protTaxId + "-" + pTaxsub
  ind1099: boolean;
  paidTotal: string;
  dateScheduled: Date;
  payVia: string;
  dateVoid: Date;
  uniqueKey: string;
  attributes: Attributes[];
  unalloc: string;
  dateMailed: Date;
}

// Helper functions for computing concatenated fields (for GetPaymentById responses)
export function formatPaymentType(payment: Payment): string {
  return payment.paymentType ?? `${payment.payTypeName}/${payment.payType}`;
}

export function formatAddress(payment: Payment): string {
  return (
    payment.address ??
    [payment.address1, payment.address2, payment.address3]
      .filter((x) => x)
      .join(' ')
  );
}

export function formatTaxId(payment: Payment): string {
  return payment.taxId ?? `${payment.protTaxId}-${payment.pTaxsub}`;
}
